import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import Navbar from "@/components/landing/Navbar";
import Hero from "@/components/landing/Hero";
import Marquee from "@/components/landing/Marquee";
import About from "@/components/landing/About";
import Services from "@/components/landing/Services";
import Stats from "@/components/landing/Stats";
import HowItWorks from "@/components/landing/HowItWorks";
import Promise from "@/components/landing/Promise";
import Pricing from "@/components/landing/Pricing";
import Testimonials from "@/components/landing/Testimonials";
import Faq from "@/components/landing/Faq";
import Footer from "@/components/landing/Footer";

export default function Landing() {
  const [content, setContent] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    api.get("/content").then((r) => setContent(r.data)).catch(() => setError(true));
  }, []);

  if (error) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-[#FAF9F5]" data-testid="landing-error">
        <p className="font-mono text-sm text-[#8896AB]">Unable to load site content. Please refresh.</p>
      </div>
    );
  }

  if (!content) {
    return (
      <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-[#FAF9F5]" data-testid="landing-loader">
        <span className="flex h-14 w-14 animate-pulse-glow items-center justify-center rounded-2xl bg-gradient-to-br from-[#B8860B] to-[#9A6A15] font-syne text-2xl font-bold text-white">
          {"\u0950"}
        </span>
        <span className="font-mono text-xs uppercase tracking-[0.3em] text-[#8896AB]">loading rails</span>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#FAF9F5] text-[#0F1B2B]" data-testid="landing-page">
      <Navbar brand={content.brand} />
      <Hero hero={content.hero} brand={content.brand} slides={content.heroSlides} />
      <Marquee items={content.marquee} />
      <About about={content.about} />
      <Services services={content.services} />
      <Stats stats={content.stats} />
      <HowItWorks steps={content.howItWorks} />
      <Promise items={content.promise} />
      <Pricing plans={content.pricing} />
      <Testimonials items={content.testimonials} />
      <Faq faqs={content.faqs} />
      <Footer brand={content.brand} contact={content.contact} social={content.social} footer={content.footer} />
    </div>
  );
}
